import { render, staticRenderFns } from "./CourseQuizCustom.vue?vue&type=template&id=9a60588e&scoped=true&"
import script from "./CourseQuizCustom.vue?vue&type=script&lang=js&"
export * from "./CourseQuizCustom.vue?vue&type=script&lang=js&"
import style0 from "./CourseQuizCustom.vue?vue&type=style&index=0&id=9a60588e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60588e",
  null
  
)

export default component.exports